export class ConstructionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBudget({ applicationId, signal }) {
    return this.#http.get(`/api/applications/${applicationId}/construction/budget`, { signal });
  }

  async createBudget({ applicationId, payload, signal }) {
    return this.#http.post(`/api/applications/${applicationId}/construction/budget`, payload, {
      signal,
    });
  }

  async saveBudget({ applicationId, payload, signal }) {
    return this.#http.put(`/api/applications/${applicationId}/construction/budget`, payload, {
      signal,
    });
  }

  async getDrawRequests({ applicationId, signal }) {
    return this.#http.get(`/api/applications/${applicationId}/construction/draw-requests`, {
      signal,
    });
  }

  async createDrawRequest({ applicationId, payload, signal }) {
    return this.#http.post(
      `/api/applications/${applicationId}/construction/draw-requests`,
      payload,
      { signal },
    );
  }

  async decideDrawRequest({ applicationId, drawRequestId, payload, signal }) {
    return this.#http.put(
      `/api/applications/${applicationId}/construction/draw-requests/${drawRequestId}/decision`,
      payload,
      { signal },
    );
  }
}
